import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="callout-swipe"
export default class extends Controller {
  connect() {
    if (!this.shouldEnableSwipe()) return // Exit if conditions are not met

    // 1. Grab the parent container (this.element) and all .container slides
    const container = this.element
    const slides = container.querySelectorAll('.container')

    // 2. Only run logic if we have at least one .container
    if (slides.length === 0) return

    // 3. Flag to debounce wheel events
    let isScrolling = false

    // 4. Listen for 'wheel' event. passive: false so we can prevent default scroll
    container.addEventListener('wheel', (event) => {
      event.preventDefault() // Stop browser’s default scroll so we can control it
      if (isScrolling) return // If already scrolling, ignore new wheel events
      isScrolling = true

      // 5. Calculate current slide index based on container.scrollLeft
      const slideWidth = slides[0].offsetWidth // Assuming all slides have same width
      const currentScroll = container.scrollLeft
      const currentSlideIndex = Math.round(currentScroll / slideWidth)

      // 6. Decide next or previous slide
      let targetSlideIndex
      if (event.deltaY > 0 || event.deltaX > 0) {
        // Scrolling down or right → next slide
        targetSlideIndex = Math.min(currentSlideIndex + 1, slides.length - 1)
      } else {
        // Scrolling up or left → previous slide
        targetSlideIndex = Math.max(currentSlideIndex - 1, 0)
      }

      // 7. Scroll smoothly to the new position
      const newScrollPosition = targetSlideIndex * slideWidth
      container.scrollTo({ left: newScrollPosition, behavior: 'smooth' })

      // 8. Reset isScrolling after the animation finishes
      setTimeout(() => {
        isScrolling = false
      }, 1000) // Adjust to match desired smooth scroll duration
    }, { passive: false }) // Important: must be false to prevent default
  }

  shouldEnableSwipe() {
    const isMobileDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0
    const isSmallScreen = window.innerWidth < 768
    return isMobileDevice || isSmallScreen
  }
}
